(() => {
  const frame = document.getElementById('CSCProofFrame');
  const message = document.getElementById('CSCProofMessage');
  const token = window.CSCReviewToken;
  delete window.CSCReviewToken;
  if (!frame || !/^[a-f0-9]{64}$/.test(token || '')) return;
  const origin = 'https://csc-artwork-service.sales-99c.workers.dev';
  frame.src = origin + '/proofs/review?t=' + encodeURIComponent(token);
  frame.hidden = false;
  message.textContent = 'Review each detail below before approving. Opening this page does not approve your proof.';
  window.addEventListener('message', event => {
    if (event.origin !== origin || event.source !== frame.contentWindow || event.data?.type !== 'csc-proof-height') return;
    const height = Number(event.data.height);
    if (Number.isFinite(height) && height > 0) frame.style.height = Math.min(12000, Math.max(350, height)) + 'px';
  });
})();
